<template>
  <div class="home" v-if="info">
    <!-- 顶部状态栏 -->
    <!--    <div class="status-bar">
          <div class="status-icons">
            <i class="signal"></i>
            <i class="wifi"></i>
            <i class="battery"></i>
          </div>
        </div>-->

    <!-- Banner区域 -->
    <div class="banner-swiper" v-if="model === 1">
      <banner :list="info.bannerList" :bannerDuration="bannerDuration" @slide-click="handleBannerClick">
        <template slot-scope="scope">
          <div class="adv-slide">
            <img class="banner-img" :src="scope.data" alt="banner" />
          </div>
        </template>
      </banner>
    </div>
    <!-- <div class="banner" v-else>
      <div class="banner-content">
        <h1 class="title">零碳旅呈，携手同行</h1>
        <p class="subtitle">ZERO CARBON TRAVEL PRESENTS WALKING HAND IN HAND</p>
      </div>
      <img class="banner-img" src="../assets/images/wechat.png" alt="banner" />
    </div> -->
    <!-- 内容区域 -->
    <div class="main">
      <!-- 微信添加区域 -->
      <div class="wechat-section">
        <div class="title-container">
          <span class="section-title">{{
            info.hotelName || "添加门店微信"
          }}</span>
        </div>
        <!--  -->
        <!-- 单行 -->
        <template v-if="model === 1">
          <div
            class="wechat-button"
            @click="handleAddWechat(item)"
            v-for="(item, index) in info.pointChannelConfigList"
          >
            <img class="wechat-icon" :src="item.imgUrl" alt="微信" />
          </div>
        </template>
        <!-- 样式一、二 -->
        <template v-if="model === 2">
          <!-- 广告位 -->
          <div class="adv-wrap">
            <banner :list="[1, 2, 3, 4]">
              <template slot-scope="scope">
                <div class="adv-slide">
                  {{ JSON.stringify(scope.data) }}
                </div>
              </template>
            </banner>
          </div>
          <!-- 一行两个 -->
          <div class="column-wrap">
            <div
              class="column-wechat-button"
              @click="handleAddWechat"
              v-for="value in 3"
              :key="value"
              :class="[{ 'new-column-wechat-button ': value === 3 }]"
            >
              <div class="wechat-button-top">
                <img
                  class="wechat-icon"
                  src="../assets/images/message.png"
                  alt="微信"
                />
                <span class="wechat-font">企业微信</span>
              </div>
              <div class="service-hint wechat-button-bottom">
                <img alt="" src="../assets/images/gantanhao2.png" />
                <span class="hint-text">当前文字只做参考</span>
              </div>
            </div>
          </div>
        </template>
      </div>
      <!-- 社交媒体区域 -->
      <div class="social-section">
        <div class="social-title">
          {{ info.otherServiceTitle || "" }}
        </div>
        <div class="social-list">
          <div
            v-for="(item, index) in info.otherChannelConfigList"
            :key="index"
            class="social-item"
            @click="handleSocialClick(item)"
          >
            <img :src="item.logo" :alt="item.logo" />
            <div class="content">
              <span style="font-size: 14px;">{{ item.channelName }}</span>
              <span style="font-size: 12px;" v-if="item.description">{{ item.description }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonApi } from "@/api";
import banner from "@/components/swiper.vue";
export default {
  name: "HomePage",
  components: { banner },
  data() {
    return {
      socialPlatforms: [
        // {
        //   id: 1,
        //   name: '抖音',
        //   icon: require('@/assets/images/douyin.png'),
        //   isShow: true
        // },
        // {
        //   id: 2,
        //   name: 'App',
        //   icon: require('@/assets/images/app.png'),
        //   isShow: true
        // }
      ],
      validSocialPlatforms: [],
      dyMerchantId: "",
      jumpPage: false,
      existWechatChannel: false,
      title: "",
      model: 1,
      info: null,
      bannerDuration: 2000,
    };
  },
  created() {
    this.newRecordOpenTimes();
    this.init();
  },
  methods: {
    // Banner点击事件处理
    async handleBannerClick(bannerItem, index) {
      await this.newRecordOpenTimes({
        merchantChannelId: 10,
        bannerId: bannerItem.bannerId,
      });
      // 跳转到超链接
      if (bannerItem.linkUrl) {
        window.location.href = bannerItem.linkUrl;
      } else {
        console.warn("Banner没有配置跳转链接");
      }
    },
    async handleAddWechat(item) {
      await this.newRecordOpenTimes({
        merchantChannelId: item.type === 1 ? 0 : 4,
      });
      window.location.href = item.redirectUrl;
    },
    async handleSocialClick(item) {
      await this.newRecordOpenTimes({
        merchantChannelId: item.channelId,
      });
      window.location.href = item.redirectUrl;
    },
    // 数据上报
    async newRecordOpenTimes(option = {}) {
      const urlParams = this.$route.query; //new URLSearchParams(window.location.search);
      const res = await commonApi.newRecordOpenTimes({
        ...option,
        channel: this.$route.query?.jump ? 2 : 1,
        merchantId: urlParams["nfcConfig"],
        type: urlParams["type"] || 0,
      });
      console.log(res);
    },
    async init() {
      try {
        // 从地址上获取 问号后面的参数id
        const urlParams = this.$route.query; //new URLSearchParams(window.location.search);
        this.jumpPage = urlParams["jump"] == 1;
        // eslint-disable-next-line camelcase
        const request_data = {
          id: urlParams["nfcConfig"],
          webApplyChannel: this.jumpPage == 1 ? 1 : 0,
        };
        const result = await commonApi.getNewNfcConfigItem(request_data);
        console.log("result:'", result)
        if (!result) {
          console.error('获取配置数据为空');
          return;
        }
        this.info = result;
        this.title = result.channelTitle;
        this.bannerDuration = result.bannerDuration;
      } catch (error) {
        console.error("无效地址:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.home {
  //overflow-y: auto; /* 仅在容器内允许滚动 */
  overflow: hidden;
  -webkit-overflow-scrolling: touch; /* 启用弹性滚动 */
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  .banner {
    position: relative;
    margin-bottom: -21px;
    height: 175px;
    .banner-content {
      position: absolute;
      top: 44px; // 状态栏高度
      left: 26px; // 左边距26px
      z-index: 2;

      .title {
        font-size: 20px;
        font-weight: bold;
        color: $white;
        margin-bottom: 4px;
      }

      .subtitle {
        font-size: 12px;
        color: rgba($white, 0.8);
        max-width: 209px; // 设置最大宽度
        line-height: 1.4; // 适当的行高
        word-wrap: break-word; // 确保长单词也会换行
        text-transform: uppercase; // 确保全大写
      }
    }

    .banner-img {
      width: 100%;
      display: block;
    }
  }
  .banner-swiper {
    position: relative;
    margin-bottom: -21px;
    height: 175px;
    .adv-slide {
      background-image: url(../assets/images/wechat.png);
      height: 175px;
      position: relative;
      .banner-content {
        position: absolute;
        top: 44px; // 状态栏高度
        left: 26px; // 左边距26px
        z-index: 2;

        .title {
          font-size: 20px;
          font-weight: bold;
          color: $white;
          margin-bottom: 4px;
        }

        .subtitle {
          font-size: 12px;
          color: rgba($white, 0.8);
          max-width: 209px; // 设置最大宽度
          line-height: 1.4; // 适当的行高
          word-wrap: break-word; // 确保长单词也会换行
          text-transform: uppercase; // 确保全大写
        }
      }

      .banner-img {
        width: 100%;
      }
    }
    ::v-deep .swiper-pagination {
      bottom: 41px;
      text-align: left;
      padding-left: 27px;
    }
  }
  .main {
    border-radius: 20px 20px 0 0;
    background: #f2f4f8;
    position: relative;
    &::before {
      height: 120px;
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      content: " ";
      border-radius: 20px 20px 0 0;
      z-index: 1;
      background: linear-gradient(180deg, #ffffff 0%, #f2f4f8 100%);
    }
    flex: 1;
    padding: 13px 0 34px 0;
    .wechat-section {
      margin: 0 18px;
      position: relative;
      z-index: 2;
      .title-container {
        font-size: 0;
        .section-title {
          font-size: 15px;
          color: #000000;
          font-weight: bold;
          background: url(../assets/images/title_bg_2x.png) no-repeat 4px 8px; /* 替换为你的背景图路径 */
          background-size: 60px; /* 保持图片比例 */
          padding-bottom: 4px;
          display: inline-block;
        }
      }
      .wechat-button {
        border-radius: 12px;
        color: $white;
        overflow: hidden;
        margin-top: 16px;
        img {
          width: 100%;
        }
        .wechat-button-top {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          background-image: url("@/assets/images/card-img/card-bg.png");
          background-size: 100%;
          background-repeat: no-repeat;
          padding: 27px 10px;
          box-sizing: border-box;
          background-color: #d6eef5;
          .wechat-icon {
            width: 26px;
            height: 26px;
            margin-right: 6px;
          }
          .wechat-font {
            font-size: 20px;
            font-weight: bold;
            color: #37838c;
          }
        }

        .service-hint {
          display: flex;
          padding: 10px 12px;
          background: linear-gradient(
            180deg,
            rgba(113, 200, 210, 0.1) 0%,
            rgba(113, 200, 210, 0.2) 50%,
            rgba(113, 200, 210, 0.1) 100%
          );
          box-shadow: inset 0px 1px 0px 0px #ffffff;
          img {
            width: 15px;
            height: 15px;
          }
          .hint-text {
            margin-left: 3px;
            color: rgba(56, 159, 171, 1);
            font-size: 12px;
          }
        }
      }
      .adv-wrap {
        margin: 18px 0 2px;
        box-sizing: border-box;
        overflow: hidden;
        height: 120px;
        .adv-slide {
          background-color: red;
          height: 120px;
          border-radius: 8px;
        }
      }
      .column-wrap {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .column-wechat-button {
          width: calc(50% - 7px);
          border-radius: 12px;
          overflow: hidden;
          color: $white;

          margin-top: 16px;
          &:nth-child(2n) {
            margin-right: 0;
          }
          .wechat-button-top {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            background-image: url("@/assets/images/card-img/card-wx.png");
            background-size: 100%;
            background-repeat: no-repeat;
            padding: 27px 10px;
            box-sizing: border-box;
            background-color: #d6eef5;
            .wechat-icon {
              width: 26px;
              height: 26px;
              margin-right: 6px;
            }
            .wechat-font {
              font-size: 20px;
              font-weight: bold;
              color: #37838c;
            }
          }

          .service-hint {
            display: flex;
            padding: 10px;
            box-shadow: inset 0px 1px 0px 0px #ffffff;
            background: linear-gradient(
              180deg,
              rgba(113, 200, 210, 0.1) 0%,
              rgba(113, 200, 210, 0.3) 50%,
              rgba(113, 200, 210, 0.1) 100%
            );
            img {
              width: 15px;
              height: 15px;
            }
            .hint-text {
              margin-left: 3px;
              color: rgba(56, 159, 171, 1);
              font-size: 11px;
            }
          }
        }
        .new-column-wechat-button {
          .wechat-button-top {
            background-color: #d2ecff;
            background-image: url("@/assets/images/card-img/card-xc.png");
          }
          .service-hint {
            display: flex;
            padding: 10px;
            background: linear-gradient(
              180deg,
              rgba(183, 225, 255, 0.1) 0%,
              rgba(183, 225, 255, 0.4) 50%,
              rgba(183, 225, 255, 0.2) 100%
            );

            img {
              width: 15px;
              height: 15px;
            }
            .hint-text {
              margin-left: 3px;
              color: rgba(56, 159, 171, 1);
              font-size: 11px;
            }
          }
        }
      }
    }

    // 社交
    .social-section {
      .social-title {
        font-size: 14px;
        color: #000000;
        padding: 16px 18px 15px;
      }
      .social-list {
        background: #ffffff;
        box-shadow: 0px 1px 2px 0px rgba(209, 208, 208, 0.03);
        border-radius: 10px;
        margin: 0 18px;
        .social-item {
          display: flex;
          align-items: center;
          padding: 1px 10px 0 12px;
          img {
            width: 24px;
            height: 24px;
            margin-right: 8px;
          }
          .content {
            flex: 1;
            height: 59px;
            line-height: 59px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);
            font-weight: 500;
            font-size: 14px;
            color: #2d2f38;
            position: relative;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-right: 13px;
            // 箭头向右
            &:before {
              position: absolute;
              right: 0;
              top: 50%;
              margin-top: -3px;
              content: " ";
              width: 6px;
              height: 6px;
              border-top: 1px solid #d5d6da;
              border-right: 1px solid #d5d6da;
              transform: rotate(45deg);
            }
            .right-name {
              font-size: 10px;
              font-weight: 400;
            }
          }
          &:last-child {
            .content {
              border-bottom-width: 0px;
            }
          }
        }
      }
    }
  }
}

.status-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 44px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: $white;
  z-index: 100;
}

// .social-section {
//   .social-list {
//     display: flex;
//     flex-wrap: wrap; // 支持多行展示
//     //justify-content: space-between;
//     padding: 0 20px;
//     gap: 20px; // 设置行与行之间的间距

//     // 当只有两个元素时的特殊样式
//     //&.two-items {
//     //  justify-content: center; // 居中对齐
//     //  gap: 10px !important; // 强制设置两个元素之间的间距
//     //}
//   }

//   .social-item {
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     gap: 8px;
//     width: calc(33.33% - 15px); // 每行最多显示3个元素
//     box-sizing: border-box;

//     img {
//       width: 88px;
//       height: 88px;
//       border-radius: $border-radius-base;
//     }

//     span {
//       font-size: $font-size-base;
//       color: $text-color;
//       font-weight: bold;
//     }
//   }
// }
</style>
